"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "54.78",
    height: "24",
    viewBox: "0 0 54.78 24",
    fill: "#93c01f"
  }, props), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "25.11 13.5 25.11 7.19 30.37 10.35 25.11 13.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "14.81",
    y: "5.17",
    width: "5.12",
    height: "6.47",
    rx: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.86,11.13V5.67a.5.5,0,0,0-.5-.5H0v6.46H13.36A.5.5,0,0,0,13.86,11.13Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "34.85",
    y: "5.17",
    width: "5.12",
    height: "6.47",
    rx: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.21,0a.75.75,0,0,0-.75.75V19.83H28.14a.74.74,0,0,0-.75.75.74.74,0,0,0-.75-.75H23.32V.75A.75.75,0,0,0,22.57,0H0V1.49H21.82V13.94H0v1.9H21.82v4H0v1.49H5.22a3.89,3.89,0,0,0,7.39,0h.53a3.89,3.89,0,0,0,7.39,0h6.11a.74.74,0,0,0,.75-.74.74.74,0,0,0,.75.74h6.11a3.89,3.89,0,0,0,7.39,0h.53a3.89,3.89,0,0,0,7.39,0h5.21V19.83H33v-4H54.77v-1.9H33V1.49H54.77V0ZM8.92,22.5a2.41,2.41,0,0,1-2.07-1.18H11A2.38,2.38,0,0,1,8.92,22.5Zm7.91,0a2.39,2.39,0,0,1-2.06-1.18H18.9A2.41,2.41,0,0,1,16.83,22.5Zm31.1-1.18a2.41,2.41,0,0,1-2.07,1.18,2.38,2.38,0,0,1-2.06-1.18Zm-10.41,0H40a2.4,2.4,0,0,1-4.13,0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M40.92,5.67v5.46a.5.5,0,0,0,.5.5H54.77V5.17H41.42A.5.5,0,0,0,40.92,5.67Z"
  }));
};

exports["default"] = _default;